import { render, staticRenderFns } from "./InfoPromosTime.vue?vue&type=template&id=d9f94c4c&scoped=true&"
import script from "./InfoPromosTime.vue?vue&type=script&lang=js&"
export * from "./InfoPromosTime.vue?vue&type=script&lang=js&"
import style0 from "./InfoPromosTime.vue?vue&type=style&index=0&id=d9f94c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f94c4c",
  null
  
)

export default component.exports